import { REACT_APP_BUILD_ENV } from '../constants/envs';

import logger from './logger';

/**
 * Throws an error with the given message in a development environment, logs the error in other environments.
 * @param message - The error message to throw or log.
 */
export const ThrowError = (message: string): void => {
  if (REACT_APP_BUILD_ENV === 'dev-local') {
    throw new Error(message);
  } else {
    logger.error(message);
  }
};
